import { render, staticRenderFns } from "./PgaValutazioneOffertaRisorseUmaneDetails.vue?vue&type=template&id=78685ac7&"
import script from "./PgaValutazioneOffertaRisorseUmaneDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaRisorseUmaneDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78685ac7')) {
      api.createRecord('78685ac7', component.options)
    } else {
      api.reload('78685ac7', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaRisorseUmaneDetails.vue?vue&type=template&id=78685ac7&", function () {
      api.rerender('78685ac7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaRisorseUmaneDetails.vue"
export default component.exports